import {EvkHttpService, EvkMainFilterPage, EvkPageServiceBase, ResponsePage} from "@evomatik/evk-common";
import {EvkExpedienteModel} from "../models/evk-expediente.model";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class ExpedientesPageService extends EvkPageServiceBase<EvkExpedienteModel> {
    private filtro = {};
    constructor(
        public http: EvkHttpService,
        public mainFilter: EvkMainFilterPage
    ) {
        super(http, mainFilter);
        this.mainFilter.setOrder('created');
        this.mainFilter.setSort('desc');
    }

    get api(): string {
        return "/seaged-expedientes-service/expediente/page";
    }

    evkOnBeforePage(): Observable<any> {
        return new Observable<any>(observer => {
            observer.next();
        });
    }

    evkOnDonePage(response: ResponsePage<EvkExpedienteModel>): ResponsePage<EvkExpedienteModel> {
        return response;
    }

    get filters(): { [p: string]: string } {
        return this.filtro;
    }
    public addFilter(key, value) {
        if(value){
            this.filtro[key] = value;
        }
    }

    public deleteFilter(key) {
        delete this.filtro[key];
    }

    public deleteAllFilter() {
        this.filtro = {};
    }
}
